module.exports = __webpack_public_path__ + "static/media/diamond-gems.7e560faf.png";